// import { useRef, useState } from "react";

// interface Props {
//   label: string;
//   onFilesSelected?: (files: File[]) => void;
//   multiple?: boolean;
// }

// export default function ImageUpload({
//   label,
//   onFilesSelected,
//   multiple = true,
// }: Props) {
//   const [fileNames, setFileNames] = useState<string[]>([]);
//   const inputRef = useRef<HTMLInputElement | null>(null);

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = Array.from(e.target.files ?? []);
//     setFileNames(files.map((f) => f.name));
//     onFilesSelected?.(files);
//   };

//   return (
//     <div>
//       <label className="block mb-1 font-medium">{label}</label>
//       <div
//         className="border-2 border-dashed rounded-lg p-6 text-center cursor-pointer hover:bg-gray-50"
//         onClick={() => inputRef.current?.click()}
//       >
//         <p className="mb-2 text-sm text-gray-600">
//           {multiple ? "Drop or click to upload images" : "Choose an image"}
//         </p>
//         <input
//           type="file"
//           name="images[]"
//           accept="image/*"
//           multiple={multiple}
//           ref={inputRef}
//           onChange={handleChange}
//           className="hidden"
//         />

//         {fileNames.length > 0 && (
//           <ul className="mt-4 space-y-1 text-sm text-gray-700">
//             {fileNames.map((n) => (
//               <li key={n}>{n}</li>
//             ))}
//           </ul>
//         )}
//       </div>
//     </div>
//   );
// }


import React from "react";

interface ImageUploadProps {
  label: string;
  multiple?: boolean;
  onFilesSelected: (files: File[]) => void;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  label,
  multiple = false,
  onFilesSelected,
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    onFilesSelected(Array.from(e.target.files));
  };

  return (
    <div>
      <label className="block mb-1 font-medium">{label}</label>
      <input
        type="file"
        multiple={multiple}
        accept="image/*"
        onChange={handleFileChange}
        className="border rounded p-2 w-full cursor-pointer"
      />
    </div>
  );
};

export default ImageUpload;